// import React from "react";

// import * as Icon from "react-feather";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faCarRear, faUsers } from "@fortawesome/free-solid-svg-icons";

// export const SidebarData = [
//   {
//     // label: "Main",
//     submenuOpen: true,
//     showSubRoute: false,
//     submenuHdr: "Main",
//     submenuItems: [
//       { label: "Dashboard", icon: <Icon.Grid />, submenu: false, showSubRoute: false, link: "/" },
//       // {
//       //   label: "Dashboards",
//       //   link: "/",
//       //   icon: <Icon.Grid />,
//       //   submenu: true,
//       //   showSubRoute: false,
//       //   submenuItems: [
//       //     { label: "Dashboard", link: "/", showSubRoute: false },
//       //     { label: "Technician Dashboard", link: "/TechnicianDashboard", showSubRoute: false },
//       //     { label: "Work Bay Dashboard", link: "/WorkBayDashboard", showSubRoute: false },
//       //   ],
//       // },
//       {
//         label: "Showroom", icon: <FontAwesomeIcon icon={faCarRear} />, submenu: true, showSubRoute: false,
//         submenuItems: [
//           { label: "Customer Inquiry", link: "/visiting", showSubRoute: false },
//           { label: "Add Prospect", link: "/lead", showSubRoute: false },
//           { label: "Qualified Prospect", link: "/opportunity", showSubRoute: false },
//           { label: "Test Drive", link: "/test-drive", showSubRoute: false },
//           { label: "Quotation", link: "/quotation", showSubRoute: false },
//         ],
//       },
//       {
//         label: "Vehicle Sales", icon: <Icon.FileText />, submenu: true, showSubRoute: false,
//         submenuItems: [
//           { label: "Add Sales", link: "/sales-add", showSubRoute: false },
//           { label: "Order List", link: "/sales-inquiries", showSubRoute: false },
//           { label: "Payments", link: "/payments", showSubRoute: false },
//           { label: "Cancel/ChangeSaleRequest", link: "/cancleandchangesaleRequest", showSubRoute: false },
//           { label: "Cancelled Sale", link: "/Cancelled-Sales", showSubRoute: false },
//         ],
//       },
//       {
//         label: "Deliveries", icon: <Icon.Folder />, submenu: true, showSubRoute: false,
//         submenuItems: [
//           { label: "Vehicle Stock", link: "/stock", showSubRoute: false },
//           { label: "Stock Movement", link: "/StockMovement", showSubRoute: false },
//         ],
//       },
//       { label: "CRM", icon: <Icon.Trello />, submenu: true, showSubRoute: false,
//         submenuItems: [
//           { label: "CRM Inquiry", link: "/CrmInquiry", showSubRoute: false },
//           { label: "CRM Complain", link: "/CrmComplaint", showSubRoute: false },
//         ],
//       },
//       { label: "After Sales", icon: <Icon.ShoppingBag />, submenu: true, showSubRoute: false,
//         submenuItems: [
//           {
//             label: "Appointments",
//             submenu: true,
//             submenuItems: [
//               { label: "Appointment Due List", link: "/CustomersList", },
//               { label: "Add Appointment", link: "/add-appointment", },
//               // { label: "Appointment Reconfirmation", link: "/AppointmentReconfirmation", },
//               { label: "Confirm Appointments", link: "/crm-appointments", },
//             ],
//           },
//           { label: "Estimation", submenu: true,
//             submenuItems: [
//               { label: "Add Estimation ", link: "/JobCard", },
//               { label: "Estimations List", link: "/job-card-estimations", },
//               // { label: "Inspection List", link: "/job-card-inspections", },
//               // { label: "Open Job Cards", link: "/job-card-inquiries", },
//             ],
//           },
//           { label: "Job Card", submenu: true,
//             submenuItems: [
//               // { label: "Create Estimate ", link: "/JobCard", },
//               // { label: "Estimation List", link: "/job-card-estimations", },
//               { label: "Open Inspection Job Card", link: "/job-card-inspections", },
//               { label: "Open Job Card", link: "/job-card-inquiries", },
//               { label: "Post Service Follow-Up", link: "/PostServiceFollowUp", },
//             ],
//           },
//           { label: "Vehicle Card", submenu: true,
//             submenuItems: [
//               { label: "Search Vehicle", link: "/VehicleMasterList", },
//               { label: "Add Vehicle", link: "/add-vehicle", },
//               { label: "Vehicles Service History", link: "/vehicle-service-history", },
//             ],
//           },
//           { label: "Inquiries", submenu: true,
//             submenuItems: [
//               { label: "DQIR Inquiries", link: "/dqir-inquiries", },
//               { label: "Estimates Inquiries", link: "/estimates-inquiries", },
//               { label: "Invoice Inquiries", link: "/invoice-inquiries", },
//               { label: "Add Purchase Order", link: "/add-purchase-order", },
//               { label: "Purchase Order Inquiries", link: "/purchase-order-inquiries", },
//             ],
//           },
//           { label: "Parts", submenu: true,
//             submenuItems: [
//               { label: "Sale Parts", link: "/add-counter-sale", },
//               { label: "Parts Requisition Inquiries", link: "/parts-requisition-inquiries", },
//               { label: "Warranty Inquiries", link: "/warranty-inquiries", },
//             ],
//           },

//         ],
//       },
//       { label: "Inventory", icon: <Icon.Archive />, submenu: true, showSubRoute: true,
//         submenuItems: [
//           { label: "Sale Order", submenu: true,
//             submenuItems: [
//               { label: "Add Sale Order", link: "/sale-item", showSubRoute: false },
//               { label: "Sale Order List", link: "/sale-orders", showSubRoute: false },
//               { label: "Add Delivery Note", link: "/sale-delivery-note", showSubRoute: false },
//               { label: "Delivery Note List", link: "/sale-delivery-note-list", showSubRoute: false },
//             ],
//           },
//           { label: "Purchase Order", submenu: true,
//             submenuItems: [
//               { label: "Add Purchase Order", link: "/purchase-item", showSubRoute: false },
//               { label: "Purchase Order List", link: "/purchase-orders", showSubRoute: false },
//               { label: "Add Delivery Note", link: "/delivery-note", showSubRoute: false },
//               { label: "Delivery Note List", link: "/delivery-note-list", showSubRoute: false },
//             ],
//           },
//           { label: "Parts Stock", link: "/parts-stock", showSubRoute: false },
//         ],
//       },
//       { label: "Quota Request", link: "/quota-request", icon: <Icon.Box />, showSubRoute: false, submenu: false, },
//       { label: "Customers", link: "/customers", icon: <Icon.Users />, showSubRoute: false, submenu: false, },
//       { label: "Setup", icon: <Icon.Settings />, submenu: true, showSubRoute: true,
//         submenuItems: [
//           { label: "Parts", submenu: true,
//             submenuItems: [
//               { label: "Parts", link: "/parts", showSubRoute: false },
//               { label: "Make", link: "/make", showSubRoute: false },
//               { label: "Model", link: "/model", showSubRoute: false },
//               { label: "Variant", link: "/variant", showSubRoute: false },
//               { label: "Category", link: "/category", showSubRoute: false },
//               { label: "Colors", link: "/part-color", showSubRoute: false },
//             ],
//           },
//           { label: "Workshop", submenu: true,
//             submenuItems: [
//               { label: "Technician", link: "/technician", showSubRoute: false },
//               { label: "Teams", link: "/teams", showSubRoute: false },
//               { label: "Shift", link: "/shifts", showSubRoute: false },
//               { label: "Types", link: "/types", showSubRoute: false },
//               { label: "Skills", link: "/skills", showSubRoute: false },
//             ],
//           },
//           { label: "Auth", submenu: true,
//             submenuItems: [
//               { label: "Assign Roles", link: "/roles", showSubRoute: false },
//               { label: "Assign Roles Setup", link: "/auth-setup", showSubRoute: false },
//               { label: "Users", link: "/user-setup", showSubRoute: false },
//               { label: "Roles", link: "/roles-setup", showSubRoute: false },
//               { label: "Modules", link: "/module", showSubRoute: false },
//               { label: "Screens", link: "/screen", showSubRoute: false },
//               { label: "Sub Screens", link: "/sub-screen", showSubRoute: false },
//               { label: "Privileges", link: "/privileges", showSubRoute: false },
//             ],
//           },
//           { label: "Bank", link: "/bank", showSubRoute: false },
//           { label: "Color", link: "/color", showSubRoute: false },
//           { label: "City", link: "/city", showSubRoute: false },
//           { label: "Dealer", link: "/dealer", showSubRoute: false },
//           { label: "Company", link: "/company", showSubRoute: false },
//           { label: "Source", link: "/source", showSubRoute: false },
//           { label: "Vehicle", link: "/vehicle", showSubRoute: false },
//           { label: "Quota", link: "/quota", showSubRoute: false },
//           { label: "Corporate Clients", link: "/corporate-clients", showSubRoute: false },
//           { label: "Job Categories", link: "/job-categories", showSubRoute: false },
//           { label: "Taxes", link: "/taxes", showSubRoute: false },
//           { label: "Vendors", link: "/vendors", showSubRoute: false },
//         ],
//       },
//     ],
//   },
// ];

import React from "react";
import * as Icon from "react-feather";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCarRear, faUsers } from "@fortawesome/free-solid-svg-icons";

// Permission map from localStorage
const permissionMap = JSON.parse(localStorage.getItem("permissionsMap") || "{}");

// ------------------ HELPERS ------------------
const canView = (permissionMap, screenName) =>
  permissionMap?.[screenName]?.includes("View");

const buildItems = (items) => items.filter(Boolean);

const createMenu = ({ label, icon, items, link }) => {
  if (link) {
    // single link, not parent
    return canView(permissionMap, label) || !permissionMap[label]
      ? { label, icon, link, submenu: false, showSubRoute: false }
      : null;
  }

  const visibleItems = buildItems(items);
  if (!visibleItems.length) return null;

  return {
    label,
    icon,
    submenu: true,
    showSubRoute: false,
    submenuItems: visibleItems,
  };
};

// ------------------ MENU CONFIG ------------------
const SidebarData = [
  {
    submenuHdr: "Main",
    submenuOpen: true,
    submenuItems: buildItems([
      // Dashboard
      createMenu({
        label: "Dashboard",
        icon: <Icon.Grid />,
        items: buildItems([
          {
            label: "Dashboard",
            link: "/",
          },
          canView(permissionMap, "After Sales Dashboard") && {
            label: "After Sales Dashboard",
            link: "/AfterSalesDashboard",
          },
        ]),
      }),
      // ------------------ Showroom ------------------
      createMenu({
        label: "Showroom",
        icon: <Icon.Clipboard />,
        items: buildItems([
          canView(permissionMap, "Customer Inquiry") && {
            label: "Customer Inquiry",
            link: "/visiting",
          },
          canView(permissionMap, "Prospect") && {
            label: "Prospect",
            link: "/lead",
          },
          canView(permissionMap, "Qualified Prospect") && {
            label: "Qualified Prospect",
            link: "/opportunity",
          },
          canView(permissionMap, "Test Drive") && {
            label: "Test Drive",
            link: "/test-drive",
          },
          canView(permissionMap, "Quotation") && {
            label: "Quotation",
            link: "/quotation",
          },
        ]),
      }),

      // ------------------ Vehicle Sales ------------------
      createMenu({
        label: "Vehicle Sales",
        icon: <Icon.FileText />,
        items: buildItems([
          canView(permissionMap, "Add Sales") && { label: "Add Sales", link: "/sales-add" },
          canView(permissionMap, "Order List") && { label: "Order List", link: "/sales-inquiries" },
          canView(permissionMap, "Payments") && { label: "Payments", link: "/payments" },
          canView(permissionMap, "Cancel/Change Sale Request") && {
            label: "Cancel/ChangeSaleRequest",
            link: "/cancleandchangesaleRequest",
          },
          canView(permissionMap, "Cancelled Sale") && { label: "Cancelled Sale", link: "/Cancelled-Sales" },
        ]),
      }),

      // ------------------ Deliveries (OEM) ------------------
      createMenu({
        label: "Deliveries (OEM)",
        icon: <Icon.Folder />,
        items: buildItems([
          canView(permissionMap, "Vehicle Stock") && { label: "Vehicle Stock", link: "/stock" },
          canView(permissionMap, "Stock Movement") && { label: "Stock Movement", link: "/StockMovement" },
        ]),
      }),

      //   // ------------------ CRM ------------------
      createMenu({
        label: "CRM",
        icon: <Icon.Trello />,
        items: buildItems([
          canView(permissionMap, "CRM Inquiry") && { label: "CRM Inquiry", link: "/CrmInquiry" },
          canView(permissionMap, "CRM Complain") && { label: "CRM Complain", link: "/CrmComplaint" },
        ]),
      }),

      //   // Quota Request
      canView(permissionMap, "Quota Request") && { label: "Quota Request", icon: <Icon.Box />, link: "/quota-request" },

      //   // ------------------ After Sales ------------------
      createMenu({
        label: "After Sales",
        icon: <Icon.ShoppingBag />,
        items: buildItems([
          createMenu({
            label: "Appointments",
            items: buildItems([
              canView(permissionMap, "Appointment Due List") && { label: "Appointment Due List", link: "/CustomersList", },
              canView(permissionMap, "Add Appointment") && { label: "Add Appointment", link: "/add-appointment" },
              canView(permissionMap, "Confirm Appointments") && { label: "Confirm Appointments", link: "/crm-appointments" },
            ]),
          }),
          createMenu({
            label: "Estimation",
            items: buildItems([
              canView(permissionMap, "Add Estimation") && { label: "Add Estimation", link: "/JobCard" },
              canView(permissionMap, "Estimation List") && { label: "Estimations List", link: "/job-card-estimations" },
            ]),
          }),
          createMenu({
            label: "Job Card",
            items: buildItems([
              {
                label: "Year Calender",
                link: "/year-calender",
              },
              {
                label: "Workshop View",
                link: "/workshop-view",
              },
              canView(permissionMap, "Open Inspection Job Card") && {
                label: "Open Inspection Job Card",
                link: "/job-card-inspections",
              },
              canView(permissionMap, "Open Job Card") && { label: "Open Job Card", link: "/job-card-inquiries" },
              canView(permissionMap, "Post Service Follow-Up") && {
                label: "Post Service Follow-Up",
                link: "/PostServiceFollowUp",
              },
            ]),
          }),
          // createMenu({
          //   label: "Vehicle Card",
          //   items: buildItems([
          //     canView(permissionMap, "Search Vehicle") && { label: "Search Vehicle", link: "/VehicleMasterList" },
          //     canView(permissionMap, "Add Vehicle") && { label: "Add Vehicle", link: "/add-vehicle" },
          //     canView(permissionMap, "Vehicle Service History") && {
          //       label: "Vehicles Service History",
          //       link: "/vehicle-service-history",
          //     },
          //   ]),
          // }),
          // createMenu({
          //   label: "Inquiries",
          //   items: buildItems([
          //     canView(permissionMap, "DQIR Inquiries") && { label: "DQIR Inquiries", link: "/dqir-inquiries" },
          //     canView(permissionMap, "Estimates Inquiries") && { label: "Estimates Inquiries", link: "/estimates-inquiries" },
          //     canView(permissionMap, "Invoice Inquiries") && { label: "Invoice Inquiries", link: "/invoice-inquiries" },
          //     canView(permissionMap, "Add Purchase Order") && { label: "Add Purchase Order", link: "/add-purchase-order" },
          //     canView(permissionMap, "Purchase Order Inquiries") && {
          //       label: "Purchase Order Inquiries",
          //       link: "/purchase-order-inquiries",
          //     },
          //   ]),
          // }),
          // createMenu({
          //   label: "Parts",
          //   items: buildItems([
          //     canView(permissionMap, "Sale Parts") && { label: "Sale Parts", link: "/add-counter-sale" },
          //     canView(permissionMap, "Parts Requisition Inquiries") && {
          //       label: "Parts Requisition Inquiries",
          //       link: "/parts-requisition-inquiries",
          //     },
          //     canView(permissionMap, "Warranty Inquiries") && { label: "Warranty Inquiries", link: "/warranty-inquiries" },
          //   ]),
          // }),
        ]),
      }),

      //   // ------------------ Inventory ------------------
      createMenu({
        label: "Parts Inventory",
        icon: <Icon.Archive />,
        items: buildItems([
          createMenu({
            label: "Sale Order",
            items: buildItems([
              canView(permissionMap, "Add Sale Order") && { label: "Add Sale Order", link: "/sale-item" },
              canView(permissionMap, "Sale Order List") && { label: "Sale Order List", link: "/sale-orders" },
              canView(permissionMap, "Add Delivery Note") && { label: "Add Delivery Note", link: "/sale-delivery-note" },
              canView(permissionMap, "Delivery Note List") && { label: "Delivery Note List", link: "/sale-delivery-note-list" },
              canView(permissionMap, "Sale Return") && { label: "Sale Return", link: "/sale-return" },
              canView(permissionMap, "Sale Return List") && { label: " Return List", link: "/sale-return-list" },

            ]),
          }),
          createMenu({
            label: "Purchase Order",
            items: buildItems([
              canView(permissionMap, "Add Purchase Order") && { label: "Add Purchase Order", link: "/purchase-item" },
              canView(permissionMap, "Purchase Order List") && { label: "Purchase Order List", link: "/purchase-orders" },
              canView(permissionMap, "Add Delivery Note") && { label: "Add Delivery Note", link: "/delivery-note" },
              canView(permissionMap, "Delivery Note List") && { label: "Delivery Note List", link: "/delivery-note-list" },
              canView(permissionMap, "Purchase Return") && { label: "Purchase Return", link: "/purchase-return" },
              canView(permissionMap, "Purchase Return List") && { label: " Return List", link: "/purchase-return-list" },

            ]),
          }),
          canView(permissionMap, "Parts Stock") && { label: "Parts Stock", link: "/parts-stock" },
          { label: "Parts Issue", link: "/parts-issue" },
        ]),
      }),

      //   // ------------------ Customers ------------------
      canView(permissionMap, "Customers") && {
        label: "Customers",
        link: "/customers",
        icon: <Icon.Users />,
        showSubRoute: false,
        submenu: false,
      },

      //   // -------------------Reporitngs -------------------
      createMenu({
        label: "Reporting",
        icon: <Icon.BarChart />,
        items: buildItems([
          {
            label: "Pre Sales Reporting",
            link: "/SaleReporting",
          },
          {
            label: "Sales Reporting",
            link: "/SaleSummary",
          },

        ]),
      }),

      //   // ------------------ Setup (OEM) ------------------
      createMenu({
        label: "Setup (OEM)",
        icon: <Icon.Settings />,
        items: buildItems([
          createMenu({
            label: "Parts",
            items: buildItems([
              canView(permissionMap, "Parts") && { label: "Parts", link: "/parts" },
              canView(permissionMap, "Parts") && { label: "Make", link: "/make" },
              canView(permissionMap, "Parts") && { label: "Model", link: "/model" },
              canView(permissionMap, "Parts") && { label: "Variant", link: "/variant" },
              canView(permissionMap, "Parts") && { label: "Category", link: "/category" },
              canView(permissionMap, "Parts") && { label: "Colors", link: "/part-color" },
            ]),
          }),
          createMenu({
            label: "Workshop",
            items: buildItems([
              canView(permissionMap, "Workshop") && { label: "Technician", link: "/technician" },
              canView(permissionMap, "Workshop") && { label: "Holidays", link: "/holidays" },
              canView(permissionMap, "Workshop") && { label: "Teams", link: "/teams" },
              canView(permissionMap, "Workshop") && { label: "Shift", link: "/shifts" },
              canView(permissionMap, "Workshop") && { label: "Types", link: "/types" },
              canView(permissionMap, "Workshop") && { label: "Skills", link: "/skills" },
            ]),
          }),
          createMenu({
            label: "Auth",
            items: buildItems([
              canView(permissionMap, "Auth") && { label: "Assign Roles", link: "/roles" },
              canView(permissionMap, "Auth") && { label: "Assign Roles Setup", link: "/auth-setup" },
              canView(permissionMap, "Auth") && { label: "Users", link: "/user-setup" },
              canView(permissionMap, "Auth") && { label: "Roles", link: "/roles-setup" },
              canView(permissionMap, "Auth") && { label: "Modules", link: "/module" },
              canView(permissionMap, "Auth") && { label: "Screens", link: "/screen" },
              canView(permissionMap, "Auth") && { label: "Sub Screens", link: "/sub-screen" },
              canView(permissionMap, "Auth") && { label: "Privileges", link: "/privileges" },
            ]),
          }),
          canView(permissionMap, "Bank") && { label: "Bank", link: "/bank" },
          canView(permissionMap, "Color") && { label: "Color", link: "/color" },
          canView(permissionMap, "City") && { label: "City", link: "/city" },
          canView(permissionMap, "Dealer") && { label: "Dealer", link: "/dealer" },
          canView(permissionMap, "Company") && { label: "Company", link: "/company" },
          canView(permissionMap, "Source") && { label: "Source", link: "/source" },
          canView(permissionMap, "Vehicle") && { label: "Vehicle", link: "/vehicle" },
          canView(permissionMap, "Quota") && { label: "Quota", link: "/quota" },
          canView(permissionMap, "Corporate Clients") && { label: "Corporate Clients", link: "/corporate-clients" },
          canView(permissionMap, "Job Categories") && { label: "Job Categories", link: "/job-categories" },
          canView(permissionMap, "Taxes") && { label: "Taxes", link: "/taxes" },
          canView(permissionMap, "Vendors") && { label: "Vendors", link: "/vendors" },
        ]),
      }),
    ]),

    // {
    //   label: "Vehicle Sales",
    //   icon: <Icon.FileText />,
    //   submenu: true,
    //   showSubRoute: false,
    //   submenuItems: [
    //     { label: "Add Sales", link: "/sales-add", showSubRoute: false },
    //     { label: "Order List", link: "/sales-inquiries", showSubRoute: false },
    //     { label: "Payments", link: "/payments", showSubRoute: false },
    //     { label: "Cancel/ChangeSaleRequest", link: "/cancleandchangesaleRequest", showSubRoute: false },
    //     { label: "Cancelled Sale", link: "/Cancelled-Sales", showSubRoute: false },
    //   ],
    // },

    // {
    //   label: "Deliveries (OEM)",
    //   icon: <Icon.Folder />,
    //   submenu: true,
    //   showSubRoute: false,
    //   submenuItems: [
    //     { label: "Vehicle Stock", link: "/stock", showSubRoute: false },
    //     { label: "Stock Movement", link: "/StockMovement", showSubRoute: false },
    //   ],
    // },
    // {
    //   label: "CRM",
    //   icon: <Icon.Trello />,
    //   submenu: true,
    //   showSubRoute: false,
    //   submenuItems: [
    //     { label: "CRM Inquiry", link: "/CrmInquiry", showSubRoute: false },
    //     { label: "CRM Complain", link: "/CrmComplaint", showSubRoute: false },
    //   ],
    // },
    // {
    //   label: "Quota Request",
    //   link: "/quota-request",
    //   icon: <Icon.Box />,
    //   showSubRoute: false,
    //   submenu: false,
    // },
    // {
    //   label: "After Sales",
    //   icon: <Icon.ShoppingBag />,
    //   submenu: true,
    //   showSubRoute: false,
    //   submenuItems: [
    //     {
    //       label: "Appointments",
    //       submenu: true,
    //       submenuItems: [
    //         { label: "Appointment Due List", link: "/CustomersList", },
    //         { label: "Add Appointment", link: "/add-appointment", },
    //         // { label: "Appointment Reconfirmation", link: "/AppointmentReconfirmation", },
    //         { label: "Confirm Appointments", link: "/crm-appointments", },
    //       ],
    //     },
    //     {
    //       label: "Estimation",
    //       submenu: true,
    //       submenuItems: [
    //         { label: "Add Estimation ", link: "/JobCard", },
    //         { label: "Estimations List", link: "/job-card-estimations", },
    //         // { label: "Inspection List", link: "/job-card-inspections", },
    //         // { label: "Open Job Cards", link: "/job-card-inquiries", },
    //       ],
    //     },
    //     {
    //       label: "Job Card",
    //       submenu: true,
    //       submenuItems: [
    //         // { label: "Create Estimate ", link: "/JobCard", },
    //         // { label: "Estimation List", link: "/job-card-estimations", },
    //         { label: "Open Inspection Job Card", link: "/job-card-inspections", },
    //         { label: "Open Job Card", link: "/job-card-inquiries", },
    //         { label: "Post Service Follow-Up", link: "/PostServiceFollowUp", },
    //       ],
    //     },

    //     {
    //       label: "Vehicle Card",
    //       submenu: true,
    //       submenuItems: [
    //         { label: "Search Vehicle", link: "/VehicleMasterList", },
    //         { label: "Add Vehicle", link: "/add-vehicle", },
    //         { label: "Vehicles Service History", link: "/vehicle-service-history", },
    //       ],
    //     },

    //     {
    //       label: "Inquiries",
    //       submenu: true,
    //       submenuItems: [
    //         { label: "DQIR Inquiries", link: "/dqir-inquiries", },
    //         { label: "Estimates Inquiries", link: "/estimates-inquiries", },
    //         { label: "Invoice Inquiries", link: "/invoice-inquiries", },
    //         { label: "Add Purchase Order", link: "/add-purchase-order", },
    //         { label: "Purchase Order Inquiries", link: "/purchase-order-inquiries", },
    //       ],
    //     },
    //     {
    //       label: "Parts",
    //       submenu: true,
    //       submenuItems: [
    //         { label: "Sale Parts", link: "/add-counter-sale", },
    //         { label: "Parts Requisition Inquiries", link: "/parts-requisition-inquiries", },
    //         { label: "Warranty Inquiries", link: "/warranty-inquiries", },
    //       ],
    //     },

    //   ],
    // },
    // {
    //   label: "Inventory",
    //   icon: <Icon.Archive />,
    //   submenu: true,
    //   showSubRoute: true,
    //   submenuItems: [
    //     {
    //       label: "Sale Order",
    //       submenu: true,
    //       submenuItems: [
    //         { label: "Add Sale Order", link: "/sale-item", showSubRoute: false },
    //         { label: "Sale Order List", link: "/sale-orders", showSubRoute: false },
    //         { label: "Add Delivery Note", link: "/sale-delivery-note", showSubRoute: false },
    //         { label: "Delivery Note List", link: "/sale-delivery-note-list", showSubRoute: false },
    //       ],
    //     },
    //     {
    //       label: "Purchase Order",
    //       submenu: true,
    //       submenuItems: [
    //         { label: "Add Purchase Order", link: "/purchase-item", showSubRoute: false },
    //         { label: "Purchase Order List", link: "/purchase-orders", showSubRoute: false },
    //         { label: "Add Delivery Note", link: "/delivery-note", showSubRoute: false },
    //         { label: "Delivery Note List", link: "/delivery-note-list", showSubRoute: false },
    //       ],
    //     },
    //     { label: "Parts Stock", link: "/parts-stock", showSubRoute: false },
    //   ],
    // },
    // {
    //   label: "Setup (OEM)",
    //   icon: <Icon.Settings />,
    //   submenu: true,
    //   showSubRoute: true,
    //   submenuItems: [
    //     {
    //       label: "Parts",
    //       submenu: true,
    //       submenuItems: [
    //         { label: "Parts", link: "/parts", showSubRoute: false },
    //         { label: "Make", link: "/make", showSubRoute: false },
    //         { label: "Model", link: "/model", showSubRoute: false },
    //         { label: "Variant", link: "/variant", showSubRoute: false },
    //         { label: "Category", link: "/category", showSubRoute: false },
    //         { label: "Colors", link: "/part-color", showSubRoute: false },
    //       ],
    //     },
    //     {
    //       label: "Workshop",
    //       submenu: true,
    //       submenuItems: [
    //         { label: "Technician", link: "/technician", showSubRoute: false },
    //         { label: "Teams", link: "/teams", showSubRoute: false },
    //         { label: "Shift", link: "/shifts", showSubRoute: false },
    //         { label: "Types", link: "/types", showSubRoute: false },
    //         { label: "Skills", link: "/skills", showSubRoute: false },
    //       ],
    //     },
    //     {
    //       label: "Auth",
    //       submenu: true,
    //       submenuItems: [
    //         { label: "Assign Roles", link: "/roles", showSubRoute: false },
    //         { label: "Assign Roles Setup", link: "/auth-setup", showSubRoute: false },
    //         { label: "Users", link: "/user-setup", showSubRoute: false },
    //         { label: "Roles", link: "/roles-setup", showSubRoute: false },
    //         { label: "Modules", link: "/module", showSubRoute: false },
    //         { label: "Screens", link: "/screen", showSubRoute: false },
    //         { label: "Sub Screens", link: "/sub-screen", showSubRoute: false },
    //         { label: "Privileges", link: "/privileges", showSubRoute: false },
    //       ],
    //     },
    //     { label: "Bank", link: "/bank", showSubRoute: false },
    //     { label: "Color", link: "/color", showSubRoute: false },
    //     { label: "City", link: "/city", showSubRoute: false },
    //     { label: "Dealer", link: "/dealer", showSubRoute: false },
    //     { label: "Company", link: "/company", showSubRoute: false },
    //     { label: "Source", link: "/source", showSubRoute: false },
    //     { label: "Vehicle", link: "/vehicle", showSubRoute: false },
    //     { label: "Quota", link: "/quota", showSubRoute: false },
    //     { label: "Corporate Clients", link: "/corporate-clients", showSubRoute: false },
    //     { label: "Job Categories", link: "/job-categories", showSubRoute: false },
    //     { label: "Taxes", link: "/taxes", showSubRoute: false },
    //     { label: "Vendors", link: "/vendors", showSubRoute: false },
    //   ],
    // },

    // ])
  }
];

export default SidebarData;
